import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import KenSelectWrap from '../../../../global_components/KenSelect';
import './roomAvailability.css';

const RoomsCapicityData = [
  { id: '1', room: '3', capacity: 90 },
  { id: '2', room: '4', capacity: 120 },
  { id: '3', room: '5', capacity: 150 },
];

function RoomAvailablity({
  currentSeatingPlanData,
  SEATING_COLUMNS,
  setEligible,
  roomChoosen,
  setRoomChoosen,
  numStudents,
  setNumStudents,
  selectValueSpace,
  setSelectValueSpace,
  selectOptionsSpace,
  facilityData,
  handleRoomDeletion,
  handleRoomAddition
}) {
  const handleSelectChangeSpace = (e) => {
    setSelectValueSpace(e.target.value);
  };

  const [selectedItemsAvail, setSelectedItemsAvail] = useState([]);
  const [selectedItemsChoosen, setSelectedItemsChoosen] = useState([]);
  const [roomsCapicityData, setRoomsCapicityData] = useState(facilityData);
  useEffect(() => {
    if (facilityData) {
      setRoomsCapicityData(facilityData);
    }
  }, [facilityData]);
  useEffect(() => {
    const numStd = roomChoosen.reduce((cur, val) => {
      return (
        Math.floor(cur +
        val.capacity /
          (SEATING_COLUMNS /
            (SEATING_COLUMNS - (parseInt(selectValueSpace) + 2))))
      );
    }, 0);

    setNumStudents(numStd);
  }, [roomChoosen, SEATING_COLUMNS, selectValueSpace, setNumStudents]);

  useEffect(() => {
    if (roomChoosen.length > 0) {
      setEligible(true);
    }
  }, [roomChoosen, setEligible]);

  const selectHandlerAvail = (e) => {
    setSelectedItemsAvail((state) => {
      return { ...state, [e.target.name]: e.target.checked };
    });
  };

  const selectHandlerChoosen = (e) => {
    setSelectedItemsChoosen((state) => {
      return { ...state, [e.target.name]: e.target.checked };
    });
  };

  let selectedValues1 = [];
  for (const key in selectedItemsAvail) {
    if (Object.hasOwnProperty.call(selectedItemsAvail, key)) {
      const element = selectedItemsAvail[key];
      if (element) {
        selectedValues1.push(key);
      }
    }
  }
  const rightArrowHandler = () => {
    if (!selectedValues1) {
      return;
    }

    const roomChoosenArray = roomsCapicityData.filter((single) => {
      return selectedValues1.includes(single.id);
    });

    const roomAvailableArray = roomsCapicityData.filter((single) => {
      return !selectedValues1.includes(single.id);
    });

    setRoomsCapicityData(roomAvailableArray);
    setRoomChoosen((prev) => [...prev, ...roomChoosenArray]);

    setSelectedItemsAvail([]);
    handleRoomAddition(roomChoosenArray);
  };

  let selectedValues = [];
  for (const key in selectedItemsChoosen) {
    if (Object.hasOwnProperty.call(selectedItemsChoosen, key)) {
      const element = selectedItemsChoosen[key];
      if (element) {
        selectedValues.push(key);
      }
    }
  }
  const leftArrowHandler = () => {
    if (!selectedValues) {
      return;
    }

    const roomAvailableArray = roomChoosen.filter((single) => {
      return selectedValues.includes(single.id);
    });

    const roomChoosenArray = roomChoosen.filter((single) => {
      return !selectedValues.includes(single.id);
    });

    setRoomChoosen(roomChoosenArray);
    setRoomsCapicityData((prev) => [...prev, ...roomAvailableArray]);

    setSelectedItemsChoosen([]);
    handleRoomDeletion(roomAvailableArray);
  };

  return (
    <>
      <Grid container spacing={2}  alignItems="baseline" style={{marginBottom:'12px'}} >
        <Grid item sm={5} xs={12} className="flex-tabs">
          <div>
            <Typography variant="p" className="typo">
              Number of Eligible Student :{' '}
              {currentSeatingPlanData?.eligibleStudents}
            </Typography>
            <Typography variant="p" className="typo">
              Number of Students with Seating Plan : {numStudents}
            </Typography>
          </div>
        </Grid>
        <Grid item sm={2} xs={12}>
          {''}
        </Grid>

        <Grid item sm={5} xs={12} container>
          <Grid xs={8} style={{display:'flex', justifyContent:'flex-end'}}>
            <Typography variant="p" className="typo">
              Inter-Candidate Spacing
            </Typography>
          </Grid>
          <Grid xs={4} style={{display:'flex', justifyContent:'flex-start'}}>
            <KenSelectWrap
              options={selectOptionsSpace}
              value={selectValueSpace}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSpace}
              required
              autoWidth={true}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Items with two table */}
      <Grid item xs={12} sm={12}>
        <div className="seating-box" id="main_container">
          <div id="drag">
            <Grid item xs={12} sm={5}>
              <div id="left">
                <table id="table5">
                  <colgroup>
                    <col width="100%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="top-header">Room Availiblity</th>
                    </tr>
                    <tr>
                      <th>
                        <div className="flex-space-between">
                          <div>Room </div>
                          <div> Effective Capacity</div>
                        </div>
                      </th>
                    </tr>
                    {roomsCapicityData?.map((single) => {
                      return (
                        <tr key={single.id}>
                          <td>
                            {single.capacity !==null? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    className="checkbox-custom"
                                    onChange={selectHandlerAvail}
                                    name={single.id}
                                    value={single.id}
                                  />
                                }
                                label={
                                  <div
                                    id="x"
                                    className={`drag flex-space-between ${
                                      selectedValues1.includes(single.id)
                                        ? 'newCss'
                                        : ''
                                    }`}
                                  >
                                    <div>{single.room}</div>
                                    <div>
                                      {Math.floor(single.capacity /
                                        (SEATING_COLUMNS /
                                          (SEATING_COLUMNS -
                                            (parseInt(selectValueSpace) + 2))))}
                                    </div>
                                  </div>
                                }
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Grid>
            <Grid item xs={12} sm={2} className="btn-group">
              <button className="custom-btn" onClick={rightArrowHandler}>
                <ArrowForward />
              </button>
              <button className="custom-btn" onClick={leftArrowHandler}>
                <ArrowBack />
              </button>
            </Grid>
            <Grid item xs={12} sm={5}>
              <div id="right">
                <table id="table6">
                  <colgroup>
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="top-header">Room Choosen</th>
                    </tr>
                    <tr>
                      <th>
                        <div className="flex-space-between">
                          <div>Room </div>
                          <div> Effective Capacity</div>
                        </div>
                      </th>
                    </tr>
                    {roomChoosen?.map((single) => {
                      return (
                        <tr key={single.id}>
                          <td>
                            {single.capacity ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    className="checkbox-custom"
                                    onChange={selectHandlerChoosen}
                                    name={single.id}
                                    value={single.id}
                                  />
                                }
                                label={
                                  <div
                                    id="x"
                                    className={`drag flex-space-between ${
                                      selectedValues.includes(single.id)
                                        ? 'newCss'
                                        : ''
                                    }`}
                                  >
                                    <div>{single.room}</div>
                                    <div>
                                      {Math.floor(single.capacity /
                                        (SEATING_COLUMNS /
                                          (SEATING_COLUMNS -
                                            (parseInt(selectValueSpace) + 2))))}
                                    </div>
                                  </div>
                                }
                              />
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Grid>
          </div>

          {/* <div id="obj_new"></div> */}

          {/* <div id="message">Clone element with CTRL key</div> */}
        </div>
      </Grid>
    </>
  );
}

export default RoomAvailablity;
